/*
  Keeps the Buy-X-Get-Y gift in sync with the cart.

  Shopify's automatic BXGY discount prices the gift at 0 but never adds it to the
  cart — that is the whole reason this exists. It adds the gift, keeps its quantity
  at 1 per `min` trigger units, and (critically) removes it as soon as the cart
  stops qualifying: without that the discount silently lapses and the customer is
  charged full price for the "free" item.

  The rule is stamped onto the gift line (_fg_trigger / _fg_min) so pages that do
  not render the product block (cart, collections, …) can still validate and remove.
*/
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var EVT = 'action:cart:updateCart';
  var busy = false;
  var queued = false;

  function sectionsParam() {
    try {
      return HELPER_UTIL.sectionRenderUtil('cart-drawer').getSectionsString();
    } catch (e) {
      return 'cart-drawer';
    }
  }

  function announce(data) {
    document.dispatchEvent(new CustomEvent(EVT, { detail: { sections: data && data.sections } }));
  }

  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* The rule comes from Theme settings (rendered into window.__freeGift by the
     layout) so it is known on every page. The colour only exists on the product
     block; anywhere else fall back to the first eligible variant. */
  function config() {
    var g = window.__freeGift;
    if (!g || !g.trigger || !g.min) return null;
    var el = document.querySelector('[data-free-gift]');
    var picked = el && el.querySelector('[data-fg-variant]:checked');
    return {
      trigger: parseInt(g.trigger, 10),
      min: parseInt(g.min, 10) || 3,
      variant: picked ? picked.value : (g.defaultVariant || null)
    };
  }

  function giftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      var p = cart.items[i].properties || {};
      if (p._free_gift) return cart.items[i];
    }
    return null;
  }

  function triggerQty(cart, productId) {
    return cart.items.reduce(function (n, i) {
      return i.product_id === productId ? n + i.quantity : n;
    }, 0);
  }

  function addGift(variantId, qty, trigger, min) {
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', qty);
    fd.append('properties[_free_gift]', '1');
    fd.append('properties[_fg_trigger]', trigger);
    fd.append('properties[_fg_min]', min);
    fd.append('sections', sectionsParam());
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (r) { return r.json(); });
  }

  function setGiftQty(key, qty) {
    return fetch(ROOT + 'cart/change.js?sections=' + encodeURIComponent(sectionsParam()), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function decide(cart) {
    var line = giftLine(cart);
    var cfg = config();

    /* fall back to the rule stamped on the gift line, so an already-added gift is
       still validated (and removed) even if the promo was since switched off */
    var trigger = cfg ? cfg.trigger : (line ? parseInt(line.properties._fg_trigger, 10) : 0);
    var min = cfg ? cfg.min : (line ? parseInt(line.properties._fg_min, 10) : 0);
    if (!trigger || !min) return null;

    var want = Math.floor(triggerQty(cart, trigger) / min);

    if (want < 1) return line ? setGiftQty(line.key, 0) : null;
    if (!line) return cfg && cfg.variant ? addGift(cfg.variant, want, trigger, min) : null;

    if (cfg && cfg.variant && String(line.variant_id) !== String(cfg.variant)) {
      return setGiftQty(line.key, 0).then(function () {
        return addGift(cfg.variant, want, trigger, min);
      });
    }
    if (line.quantity !== want) return setGiftQty(line.key, want);
    return null;
  }

  function sync() {
    if (busy) { queued = true; return; }
    busy = true;
    getCart()
      .then(decide)
      .then(function (data) { if (data) announce(data); })
      .catch(function () { /* a gift error must never break the cart */ })
      .then(function () {
        busy = false;
        if (queued) { queued = false; sync(); }
      });
  }

  document.addEventListener(EVT, function () { sync(); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-fg-variant]')) sync();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
